import React, { Component } from "react";
import PayButton from './PayButton';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedInUser: '',
      users: [],
      items: [],
      total: 0,
      perItemTotal: 0,
      sumTotal: 0,
      splitTotal: 0,
      totalUsers: props.splitByTotalUsers || '',
      itemSelected: []
    }
    let isMobileDevice = this.detectDevice();
    if (isMobileDevice.iOS()) {
      this.state = {
        devicePlatform: 'iOS'
      }
    } else
      if (isMobileDevice.Android()) {
        this.state = {
          devicePlatform: 'android'
        }
      }
    if (isMobileDevice.any()) {
      this.state = {
        devicePlatform: 'Web'
      }
    }
  }
  detectDevice() {
    const isMobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
      },
      Web: function () {
        return navigator.userAgent.match(/Win/i) || navigator.userAgent.match(/Linux/i) || navigator.userAgent.match(/Mac/i)
      },
      any: function () {
        return (isMobile.Web()); //return Web for any other platforms
      }
    };
    return isMobile;
  }
  computeItemTotals() {
    let loggedInUser = this.props.loggedInUser;
    let users = this.props.users;
    let items = this.props.items;
    let total = 0;
    let perItemTotal = 0;
    let sumTotal = 0;
    let splitTotal = 0;
    let totalUsers;
    let tableTotal = 0;
    let itemKeys = [];
    let itemSelectedKeys = [];
    if (users) {
      totalUsers = this.state.totalUsers;
    } else {
      totalUsers = 1;
    }
    let itemsSelected = [];
    items.forEach((element, key) => {
      if ((element.userAssigned === loggedInUser) && (element.paid === false)) {
        total += element.total;
        itemsSelected.push(element);
        itemSelectedKeys.push(key);
      }
      itemKeys.push(key);
      sumTotal += element.total;
    });
    if (this.props.splitBillTotal === 0) {
      tableTotal = (this.props.tableTotal / 100).toFixed(2);
    } else {
      tableTotal = this.props.splitBillTotal;
    }
    perItemTotal = (total / 100).toFixed(2);
    splitTotal = ((sumTotal / this.state.totalUsers) / 100).toFixed(2);

    if (this.props.type === "splitequally") {
      return { splitTotal, itemKeys };
    } else if (this.props.type === "paybyitems") {
      return { perItemTotal, itemSelectedKeys, itemsSelected };
    } else {
      return {};
    }
  }
  render() {
    let itemStats = this.computeItemTotals();
    if (!this.props.type) {
      return null; //return null if the splitType is not selected Yet.
    }
    if (this.props.type === 'splitequally' && this.props.splitBillUsers && this.props.splitBillTotal && this.props.splitBillCompleted) {
      return (
        <footer className="footer navbar navbar-dark bg-dark">

          <PayButton
            tableID={this.props.tableID}
            devicePlatform={this.state.devicePlatform}
            items={this.props.items}
            sumTotal={this.props.splitBillTotal}
            itemKeys={itemStats.itemKeys}
            splitType={this.props.type}
            users={this.props.users}
            tableTotal={this.props.tableTotal}
            loggedInUser={this.props.loggedInUser}
            amountPaid={this.props.amountPaid}
            displayBillTotal={this.props.splitBillTotal}
          />

        </footer>
      )
    } else if (this.props.type === 'paybyitems' && (itemStats.itemSelectedKeys.length > 0)) {
      return (
        <footer className="footer navbar navbar-dark bg-dark">
          <PayButton
            tableID={this.props.tableID}
            devicePlatform={this.state.devicePlatform}
            items={itemStats.itemsSelected}
            sumTotal={itemStats.perItemTotal}
            itemKeys={itemStats.itemSelectedKeys}
            splitType={this.props.type}
            users={this.props.users}
            tableTotal={this.props.tableTotal}
            loggedInUser={this.props.loggedInUser}
            amountPaid={this.props.amountPaid}
            displayBillTotal={itemStats.perItemTotal}
          />
        </footer>
      )
    } else {
      return null;
    }
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Components/Footer.js